export const GET_ALL_CUSTOMER_LOADS = 'GET_ALL_CUSTOMER_LOADS'
export const GET_CUSTOMER_LOAD = 'GET_CUSTOMER_LOAD'
export const CLEAR_CUSTOMER_LOAD = 'CLEAR_CUSTOMER_LOAD'
export const CUSTOMER_LOADS_LOADING = 'CUSTOMER_LOADS_LOADING'
